<script setup>
import { computed, useAttrs, ref } from 'vue';
import {
  currentModel,
  mutateStringPath,
  getNestedProperty,
} from './currentModel';

const attrs = useAttrs();

const search = ref('');
const tempOptions = ref([]);
const opt = computed(() => {
  if (search.value.trim() != '') {
    return tempOptions.value;
  }
  return attrs.options;
});

function filterFn(val = '', update, abort) {
  update(() => {
    const needle = val.toLowerCase();
    tempOptions.value = attrs.options.filter((v) => {
      const label = attrs['option-label'] || attrs.optionLabel;
      const str = typeof v == 'string' ? v : label ? v[label] : v.label;
      return str.toLowerCase().indexOf(needle) > -1;
    });
  });
}
</script>

<template>
  <div class="flex flex-col gap-1">
    <div class="text-sm w-full">{{ $attrs.Label }}</div>
    <q-select
      class="w-full"
      outlined
      dense
      hide-dropdown-icon
      :value="getNestedProperty(currentModel, $attrs.model)"
      @input="(v) => mutateStringPath(currentModel, $attrs.model, v)"
      v-bind="$attrs"
      @input-value="(v) => (search = v)"
      @filter="filterFn"
      hide-selected
      fill-input
      input-debounce="0"
      :options="opt"
      :bg-color="$attrs.disable ? 'grey-4' : ''"
    >
      <template v-slot:append> <q-icon :name="$attrs.icon" /> </template
    ></q-select>
  </div>
</template>

<style lang="scss" scoped></style>
